import { api } from '../api/client';
import { LoginLog } from '../types';

export type { LoginLog };

export const getLatestLoginLog = async (): Promise<LoginLog | null> => {
  return api.get<LoginLog | null>('/login-logs/latest');
};

export const getLoginHistory = async (startDate?: Date, endDate?: Date): Promise<LoginLog[]> => {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate.toISOString());
  if (endDate) params.set('endDate', endDate.toISOString());
  const qs = params.toString();
  return api.get<LoginLog[]>(`/login-logs${qs ? `?${qs}` : ''}`);
};
